exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Modal_overlay__1TgzI {\n  z-index: 10;\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: rgba(0, 0, 0, 0.6); }\n\n.Modal_modal__1vwov {\n  z-index: 11;\n  background: transparent;\n  outline: none;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%); }\n", ""]);

// Exports
exports.locals = {
	"overlay": "Modal_overlay__1TgzI",
	"modal": "Modal_modal__1vwov"
};